// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Apply from "./pages/Apply";
import Dashboard from "./pages/Dashboard";
import CreateTournament from "./pages/CreateTournament";
import TournamentDetails from "./pages/TournamentDetails";
import TournamentDisplay from "./pages/TournamentDisplay";
import BlindStructures from "./pages/BlindStructures";
import ChipSets from "./pages/ChipSets";
import AdminUsers from "./pages/AdminUsers";
import AdminUserDetails from "./pages/AdminUserDetails";
import Tournaments from "./pages/Tournaments";
import PendingApplications from "./pages/PendingApplications";
import CashGames from "./pages/CashGames";
import AdminCashGames from "./pages/AdminCashGames";
import MyAccount from "./pages/MyAccount";
import ForcePasswordChange from "./pages/ForcePasswordChange";
import Communications from "./pages/Communications";
import AdminTournamentManager from "./pages/AdminTournamentManager";

import RequireAuth from "./components/RequireAuth";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/apply" element={<Apply />} />

        {/* Protected */}
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />

        <Route
          path="/cash-games"
          element={
            <RequireAuth>
              <CashGames />
            </RequireAuth>
          }
        />

        <Route
          path="/tournaments"
          element={
            <RequireAuth>
              <Tournaments />
            </RequireAuth>
          }
        />

        <Route
          path="/account"
          element={
            <RequireAuth>
              <MyAccount />
            </RequireAuth>
          }
        />

        <Route
          path="/force-password-change"
          element={
            <RequireAuth>
              <ForcePasswordChange />
            </RequireAuth>
          }
        />

        <Route
          path="/create-tournament"
          element={
            <RequireAuth>
              <CreateTournament />
            </RequireAuth>
          }
        />

        <Route
          path="/tournament/:id"
          element={
            <RequireAuth>
              <TournamentDetails />
            </RequireAuth>
          }
        />

        <Route
          path="/tournament/:id/display"
          element={
            <RequireAuth>
              <TournamentDisplay />
            </RequireAuth>
          }
        />

        {/* Admin tools */}
        <Route
          path="/admin/tournaments/:id/manage"
          element={
            <RequireAuth>
              <AdminTournamentManager />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/users"
          element={
            <RequireAuth>
              <AdminUsers />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/users/:memberId"
          element={
            <RequireAuth>
              <AdminUserDetails />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/pending-applications"
          element={
            <RequireAuth>
              <PendingApplications />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/communications"
          element={
            <RequireAuth>
              <Communications />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/cash-games"
          element={
            <RequireAuth>
              <AdminCashGames />
            </RequireAuth>
          }
        />

        <Route
          path="/blind-structures"
          element={
            <RequireAuth>
              <BlindStructures />
            </RequireAuth>
          }
        />

        <Route
          path="/chip-sets"
          element={
            <RequireAuth>
              <ChipSets />
            </RequireAuth>
          }
        />
      </Routes>
    </Router>
  );
}
